export default {
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
  ApiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  CaseApiBaseUrl: process.env.VUE_APP_CASE_API_BASE_URL,
  LettersApiBaseUrl: process.env.VUE_APP_LETTERS_API_URL,
  CaseAppBaseUrl: process.env.VUE_APP_CASE_BASE_URL,
  CaseClientID: process.env.VUE_APP_CLIENT_ID,
  CaseSecret: process.env.VUE_APP_SECRET,
  communicationApiV1BaseUrl: process.env.VUE_APP_COMMUNICATION_V1_API_URL,
}
